export { default } from './SidebarLink';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SidebarLink/index.js